export const getFixedNodesByZone = async (props, zoneId) => {
  const { apiUrl, token } = props;

  const results = await fetch(`${apiUrl}fixedNodes/zones/${zoneId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "auth-token": token,
    },
  })
    .then((response) => response.json())
    .then((response) => response)
    .catch((err) => console.log(err));
  return results;
};

export const updateRadio = async (
  props,
  slot,
  mountPointXYZ
) => {
  const { angle = null, radioId = "" } = slot;
  const { x = 0, y = 0, z = 0 } = mountPointXYZ;
  const { apiUrl, token } = props;
  const body = {
    mountPoint: {
      angle,
    },
    xyz: {
      x,
      y,
      z,
    },
  };

  const results = await fetch(`${apiUrl}radios/${radioId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "auth-token": token,
    },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((response) => response)
    .catch((err) => {
      console.log(err);
      return { error: err };
    });
  return results;
};

export const updateRadios = async (
  props,
  slots,
  mountPointXYZ
) => {
  const results = slots.map(async (slot) => {
    if (slot.radioId) {
      return await updateRadio(props, slot, mountPointXYZ);
    }
  });

  return await Promise.all(results).then((completed) => {
    if (completed.some((item) => item && item.error)) {
      return completed.filter((item) => item.error)[0];
    }
    return completed;
  });
};

const createMountPoint = async (props, mountPoint) => {
  const { apiUrl, token } = props;

  const results = await fetch(`${apiUrl}mountPoints`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "auth-token": token,
    },
    body: JSON.stringify(mountPoint),
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => {
      console.log(err);
      return { error: err };
    });

  return results;
};

const updateMountPoint = async (props, mountPoint) => {
  const { apiUrl, token } = props;

  const results = await fetch(
    `${apiUrl}mountPoints/${mountPoint.mountPointId}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "auth-token": token,
      },
      body: JSON.stringify(mountPoint),
    }
  )
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => {
      console.log(err);
      return { error: err };
    });

  return results;
};

export const upsertMountPoints = async (props, mountPoints) => {
  const results = mountPoints.map(async (mountPoint) => {
    const radioUpdates = await updateRadios(
      props,
      mountPoint.slots,
      mountPoint.xyz
    );
    if (radioUpdates.error) {
      return { error: radioUpdates.error };
    }

    if (mountPoint.mountPointId) {
      return await updateMountPoint(props, mountPoint);
    } else {
      return await createMountPoint(props, mountPoint);
    }
  });

  return await Promise.all(results).then((completed) => {
    if (completed.some((item) => item.error)) {
      return completed.filter((item) => item.error)[0];
    }
    return completed;
  });
};

export const deleteMountPoint = async (props, mountPointId) => {
  const { apiUrl = "", token = "" } = props;

  const results = await fetch(`${apiUrl}mountPoints/${mountPointId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      "auth-token": token,
    },
  })
    .then((response) => response.json())
    .then((response) => response)
    .catch((err) => console.log(err));
  return results;
};

export const getFixedNodeById = async (props, nodeId) => {
  const { apiUrl = "", token = "" } = props;

  const results = await fetch(`${apiUrl}fixedNodes/${nodeId}`, {
    headers: {
      "Content-Type": "application/json",
      "auth-token": token,
    },
  })
    .then((response) => response.json())
    .then((response) => response)
    .catch((err) => console.log(err));
  return results;
};
